import { createSlice } from '@reduxjs/toolkit'
import {getFactoryBranches} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  branches: [], 
  loading: "idle",
  error: null }

const factoryBranchesSlice = createSlice({
  name: 'factoryBranches',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryBranches.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryBranches.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.branches = action.payload
      
    },
    [getFactoryBranches.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryBranchesSlice.actions;
export default factoryBranchesSlice.reducer
